import { TFunction } from 'i18next';

export function shortenPeriodeLabel({
  label,
  t,
}: {
  label?: string;
  t: TFunction<['common', 'programmation']>;
}) {
  if (!label) {
    return '';
  }
  return `${label.replace(
    `${t('programmation:periode')} `,
    t('programmation:periodeShort'),
  )}`;
}
